import {ScanLine,Sun,Moon,Menu} from 'lucide-react';
import {useAuth} from '@/context/AuthContext';
import {useTheme} from '@/theme/ThemeProvider';
import BrandAsset from './BrandAsset';
export function BrandLogo({className='h-8 w-8'}){const {logoUrl}=useTheme();return logoUrl?<img src={logoUrl} alt="Logo toko" className={`${className} object-contain shrink-0`}/>:<ScanLine className={`${className} shrink-0`}/>;}
export function SidebarBrand() {
  const { current, logoUrl } = useTheme();
  return <div className="app-sidebar-brand" data-testid="sidebar-brand">
    {logoUrl ? <div className="app-sidebar-logo-surface"><BrandAsset src={logoUrl} alt={`Logo ${current.branding.name}`} className="app-sidebar-logo" testId="sidebar-full-logo" /></div>
      : <div className="flex items-center gap-3 min-w-0"><ScanLine className="h-8 w-8 shrink-0" aria-hidden="true" /><span className="font-heading font-bold truncate">{current.branding.name}</span></div>}
  </div>;
}

export default function BrandIdentity({ menuButtonRef, menuOpen, onToggleMenu, storeControl }) {
  const { current, faviconUrl, mode, setDeviceMode } = useTheme();
  const { user } = useAuth();
  const ThemeIcon = mode === 'dark' ? Moon : Sun;
  return <div className="theme-brand-bar masivi-header app-brand-identity">
    {onToggleMenu && <button ref={menuButtonRef} type="button" data-testid="toggle-sidebar-btn" className="theme-shortcut app-menu-toggle"
      aria-label={menuOpen ? 'Tutup menu' : 'Buka menu'} aria-expanded={menuOpen} aria-controls="app-sidebar" onClick={onToggleMenu}>
      <Menu size={22} aria-hidden="true" />
    </button>}
    <BrandAsset src={faviconUrl} alt={`Ikon ${current.branding.name}`} className="app-header-icon" testId="header-brand-icon" color="var(--masivi-primary)" />
    {user?.role === 'admin' && <button type="button" className="theme-shortcut" aria-label="Ganti tema perangkat" title="Ganti tema perangkat"
      onClick={() => setDeviceMode(mode === 'dark' ? 'light' : 'dark')}><ThemeIcon size={19} /></button>}
    {storeControl}
  </div>;
}
